module.exports = __webpack_public_path__ + "static/media/img-agencia.a6a643da.svg";